<template>
	<div class="tmz-list-reports">
		<div class="container">
			<div class="table-container">
				<table>
					<thead>
						<tr>
							<th>№ п/п</th>
							<th>ДЗО</th>
							<th>Отчет создан</th>
							<th>Отчет утвержден</th>
							<th>Год</th>
							<th>Месяц</th>
							<th>Дата создания</th>
							<th>Статус</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(report, index) in this.reports"
							:key="report.id"
							@click="openReport(report.id)"
						>
							<td>{{ defineIndex(index) }}</td>
							<td>{{ report.dzo.name }}</td>
							<td>
								<!--                        {{ report.create_user.first_name | TitleCase }}-->
								<!--                        {{ report.create_user.last_name | TitleCase }}-->
							</td>
							<td>
								{{
									report.approved_user
										? report.approved_user.first_name
										: '' | TitleCase
								}}
								{{
									report.approved_user
										? report.approved_user.last_name
										: '-' | TitleCase
								}}
							</td>
							<td>{{ report.year }}</td>
							<td>{{ report.month | getMonth }}</td>
							<td>{{ report.created_datetime | formatDate }}</td>
							<td>
								<p
									class="my-report-status"
									:class="getBtnColor(report.status)"
								>
									{{ report.status }}
								</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
      <div class="tmz__pagination">
        <pagination v-if="this.pageCount > 1" :currentPage="this.page" :pageCount="this.pageCount" @pageClicked="search" />
      </div>

      <!--      <button v-if="isImpl" class="delete-reports-btn" @click="deleteAllReport()">Удалить все отчеты кроме-->
			<!--          первого-->
			<!--      </button>-->
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../../store';
import NProgress from 'nprogress';
import Pagination from '../../components/shared/Pagination.vue';
import axios from "axios";

export default {
	name: 'TmzOtherReports',
  components: {
    Pagination
  },
	data() {
		return {
      page: 1,
      reports: [],
    };
	},
	beforeRouteEnter(to, from, next) {
		NProgress.start();
		store.dispatch('getTmzOtherReports', to.params.id).then(response => {
			store.dispatch('addNotification', {
				type: 'success',
				message: 'Мои отчеты обновлены',
			});
			NProgress.done();
			next();
		});
	},
	methods: {
    defineIndex(index) {
      if (this.page == 1) {
        return index + 1
      } else {
        if (index == 9) {
          return `${this.page}0`
        } else {
          return `${this.page - 1}${index + 1}`
        }
      }
    },
    search(page = 1) {
      this.page = page

      let payload = {
        page: page
      }

      // Filtering Object to pass non empty values
      let filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(([key, value]) => value !== '')
      )


      axios
          .get('/tmz/all-not-my-tmz/', {
            params: filteredPayload
          })
          .then(response => {
            this.reports = response.data.results
            store.commit('setTmzReportsCount', response.data.count)
          })
          .then(response => {
            store.dispatch('addNotification', {
              type: 'success',
              message: 'Таблица обновлена',
            });
          })
          .catch(error => {
            store.dispatch('addNotification', {
              type: 'error',
              message: error.response.data,
            });
          });
    },
		openReport(id) {
			const route = this.$router.resolve({
				name: 'view-tmz-step-first',
				params: { id: id },
			});
			window.open(route.href, '_blank');
		},
		getBtnColor(status) {
			let color = '';
			if (status === 'Создан') {
				color = 'status-green';
			} else if (status === 'Подписан исполнителем') {
				color = 'status-yellow';
			} else if (status === 'Подписан утверждающим') {
				color = 'status-yellow';
			} else if (status === 'Редактирован') {
				color = 'status-yellow';
			} else if (status === 'Авто-изменения после корректировки') {
				color = 'status-yellow';
			} else if (status === 'Утвержден получателем КМГ') {
				color = 'status-blue';
			} else if (status === 'Отклонен утверждающим') {
				color = 'status-red';
			} else if (status === 'Отклонен получателем КМГ') {
				color = 'status-red';
			}
			return color;
		},
	},
  mounted() {
    this.reports = this.otherTmzReports
  },
  computed: {
		...mapGetters(['otherTmzReports', 'tmzOtherReportsCount']),
    pageCount() {
      return Math.ceil(this.tmzOtherReportsCount / 10)
    }
	},
};
</script>

<style scoped>
.tmz-list-reports {
	margin-top: 2rem;
}

.table-filter-container {
	margin: 2rem 0;
	display: flex;
	justify-content: center;
}

.t-filter-select-company {
	max-width: 300px;
	min-width: 200px;
	height: 60px;
	border: 1px solid #e3e3e3;
	border-radius: 10px;
	appearance: none;
	/* text-align: center; */
	/* margin: 0 auto; */
	padding: 1rem 2rem;
	font-size: 1.1rem;
	margin: 0 0.5rem;
}

.t-filter-select-company:focus {
	outline: none;
}

.table-filter-submit {
	width: 200px;
	height: 60px;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

.report-actions {
	display: flex;
	justify-content: flex-end;
}

.download-btn {
	padding: 0.5rem 1rem;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

.download-select {
	border: 1px solid #e3e3e3;
	border-radius: 10px;
	appearance: none;
	padding: 0.5rem 2rem;
	font-size: 1.1rem;
	margin: 0 0.5rem 1rem;
}

.download-select:focus {
	outline: none;
}

table {
	border-collapse: collapse;
	width: 100%;
	max-width: 1460px;
	padding: 1rem;
}

thead {
	background: #f3f5ff;
	height: 70px;
}

thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

thead th:last-child {
	border-top-right-radius: 10px;
}

th {
	padding: 1rem;
	color: #565656;
}

tr {
	cursor: pointer;
}

tr:hover {
	background: #f3f5ff;
}

td {
	padding: 1rem;
	text-align: center;
	border: 1px solid #e3e3e3;
}

.my-report-status {
	/* background: #7AD38D; */
	padding: 0.5rem 2.5rem;
	border-radius: 5px;
	/* width: 180px; */
}

.status-green {
	background: #7ad38d;
	color: white;
}

.status-yellow {
	background: #ffbb56;
	color: white;
}

.status-red {
	background: #e86363;
	color: white;
}

.delete-reports-btn {
	padding: 0.5rem 2.5rem;
	border-radius: 5px;
	font-size: 1.1rem;
	border: none;
	background: #e86363;
	color: white;
	float: right;
	margin: 2rem 0;
	cursor: pointer;
}

.tmz__pagination {
  margin-top: 1.5rem;
}
</style>
